import { atom } from 'jotai'
import { GetRequest, GetRequestCached2 } from '../api'
import { urls } from '../constants'
import moment from 'moment'
import { alertAtom } from './globalStateAtoms'

export const DispatchRegisterSummaryData = atom([])
export const fetchDispatchRegisterSummary = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequestCached2(urls.DispatchRegisterMemoSummary + '?', data)
    if (res.status === 'Success') {
      const data = res.Data.table.map((a, i) => ({ ...a, SN: i + 1,NetAmount:a?.NetAmount||0 }))
      set(DispatchRegisterSummaryData, data)
    }
  } catch (error) {
    console.error('Error fetching branches:', error)
    set(DispatchRegisterSummaryData, [])
  }
})

export const GetBranchRechargeListAllData = atom([])
export const getBranchRechargeListAll = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequest(urls.getBranchRechargeListAll + '?', data)
    if (res.status === 'Success') {
      const data = res.Data.Table.map((item, index) => ({
                ...item,
                SN: index + 1,
                isDataRow: true,
                dataType: 'entry', 
                transactionDateTime: item.transactionDateTime !== '' ? moment(item.transactionDateTime).format('DD/MM/YYYY HH:mm:ss') : '',
                AcceptedOrRejectedDateTime:
                item.AcceptedOrRejectedDateTime !== '' ? moment(item.AcceptedOrRejectedDateTime).format('DD/MM/YYYY HH:mm:ss') : '',
              }))
      set(GetBranchRechargeListAllData, data)
    }else{
      set(GetBranchRechargeListAllData, [])
       set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data found' })
    }
  } catch (error) {
    console.error('Error fetching branches:', error)
    set(GetBranchRechargeListAllData, [])
  }
})
